import React, { FC } from "react";
import { CircleCheck } from "lucide-react";
import { Icon } from "src/components/icons/Icon";
import styles from "./ClientTrainingTOCSectionCompletion.module.css";

type ClientTrainingTOCSectionProps = {
	complete: boolean;
};

export const ClientTrainingTOCSectionCompletion: FC<
	ClientTrainingTOCSectionProps
> = ({ complete }) => {
	return (
		<span className={styles.content}>
			{complete && <Icon icon={CircleCheck} />}
		</span>
	);
};
